import { Badge, PanelTable } from '~/components/ui';
import type { MlsRow } from '~/components/Constants/mlsConstants';

export interface CustomerRow {
  Customer: string;
  ClientBAY: boolean;
  SocialBAY: boolean;
}

/** The customers linked to a feed, one row each, with the platforms they are connected through. */
export const feedCustomers = (feed: MlsRow): CustomerRow[] => {
  const names = new Set<string>();
  for (const target of Object.values(feed.targets ?? {}))
    for (const customer of target?.associatedCustomers ?? []) names.add(customer.name);
  const on = (platform: string, name: string) =>
    !!feed.targets?.[platform]?.associatedCustomers?.some((c) => c?.name === name);
  return [...names].map((Customer) => ({
    Customer,
    ClientBAY: on('ClientBAY', Customer),
    SocialBAY: on('SocialBAY', Customer),
  }));
};

const BayTick = ({ on }: { on: boolean }) =>
  on ? (
    <Badge color="success" size="sm">
      Connected
    </Badge>
  ) : (
    <Badge color="error" size="sm">
      Not connected
    </Badge>
  );

const MlsCustomerTable = ({ rows }: { rows: CustomerRow[] }) => (
  <PanelTable<CustomerRow>
    ariaLabel="Customers connected to this feed"
    testId="mls-customers-table"
    columns={[
      { header: 'Customer', render: (row) => <span className="font-medium">{row.Customer}</span> },
      { header: 'ClientBAY', render: (row) => <BayTick on={row.ClientBAY} /> },
      { header: 'SocialBAY', render: (row) => <BayTick on={row.SocialBAY} /> },
    ]}
    data={rows}
    emptyMessage="No customers are connected to this feed."
    emptyDescription="Customers appear here once they are linked to this feed in ClientBAY or SocialBAY."
  />
);

export default MlsCustomerTable;
